import classNames from "classnames";
import colors from "exports.module.scss";
import { memo } from "react";

import IconSeneca from "common/assets/components/icons/IconSeneca";

import styles from "./LoadingSpinner.module.scss";

type Props = {
  loading?: boolean;
  colour?: "white" | "dark";
  size?: string;
};

const LoadingSpinner = ({ loading, colour = "white", size }: Props) => {
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.sizeMedium]: size === "medium",
        [styles.sizeSmall]: size === "small" || !size,
        [styles.sizeXsmall]: size === "xsmall" || !size
      })}
    >
      {loading && (
        <IconSeneca
          className={styles.loader}
          fill={colour === "white" ? "white" : colors.dustyGray}
        />
      )}
    </div>
  );
};

export default memo<Props>(LoadingSpinner);
